'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../styleInject.js');

var css_248z = ".PickupLocationNotFound-module_root__ooXoA{align-items:center;display:flex;flex-direction:column;padding-top:.5rem;text-align:center}";
var styles = {"root":"PickupLocationNotFound-module_root__ooXoA"};
styleInject["default"](css_248z, 'c64e55b4-42f2-4247-91e0-85b428c206b9');

exports["default"] = styles;
